import { Provider } from "@angular/core";

import { IotnetService } from "../../apis/stats/rest/services";
import { IOTNET_REPOSITORY } from "./iotnet-repository.port";

/** Swapped for the mock variant via `fileReplacements` when building with the `mocks` configuration. */
export const IotnetRepositoryProvider: Provider = { provide: IOTNET_REPOSITORY, useClass: IotnetService };
